import {
  CompanyTabID,
  CompanyTabNanoID,
  CompanyTabUUID,
  DeleteCompanyTabCacheKeys,
  DeleteCompanyTabGqlQuery
} from '../../companyTabsTypes';

import { useEdDeleteQuery } from '../../../common/reactQuery/hooks/useEdDeleteQuery';
import { ErrorType } from '../../../../utils/parseRequestError';

interface DeleteCompanyTabOptions {
  query: DeleteCompanyTabGqlQuery;
  cacheKeys?: DeleteCompanyTabCacheKeys;
}

export interface DeleteCompanyTabInput {
  uid: CompanyTabUUID | CompanyTabNanoID | CompanyTabID;
}

export type DeleteCompanyTabError = ErrorType;

const action = 'deleteCompanyTab';

function useDeleteCompanyTab({ query, cacheKeys }: DeleteCompanyTabOptions) {
  const {
    deleteQuery,
    deleteQueryData,
    deleteQueryError,
    deleteQueryErrorMessage,
    deleteQueryLoading,
    deleteQueryReset
  } = useEdDeleteQuery<
    DeleteCompanyTabInput,
    DeleteCompanyTabInput,
    DeleteCompanyTabError
  >({ action, query, cacheKeys });

  return {
    deleteCompanyTab: deleteQuery,
    deleteCompanyTabData: deleteQueryData,
    deleteCompanyTabError: deleteQueryError,
    deleteCompanyTabErrorMessage: deleteQueryErrorMessage,
    deleteCompanyTabLoading: deleteQueryLoading,
    deleteCompanyTabReset: deleteQueryReset
  };
}

export default useDeleteCompanyTab;
